<nz-modal [(nzVisible)]="isOpenModal" nzClassName="common-notify"
  [nzStyle]="{'width': '380px', 'border-radius': '28px'}" (nzAfterClose)="onCloseModal.emit()"
  (nzOnCancel)="deleteCancel()" (nzOnOk)="deleteOk()" [nzMaskClosable]="false" nzCentered [nzFooter]="null"
  [nzCloseIcon]="closeIcon">
  <ng-container *nzModalContent>
    <!-- <div class="icon-notification">
      <img *ngIf="isWarning" src="../../../../assets/images/warning.png" alt="">
      <img *ngIf="isErrors" src="../../../../assets/images/errorsThungRac.svg" alt="">
      <img *ngIf="isSuccess" src="../../../../assets/images/successRing.svg" alt="">
      <img *ngIf="isDelete" src="assets/icons/icon-delete-notification.svg" alt="">
    </div> -->
    <div class="notification">
      <div class="content-notification">
        <div *ngIf="!isCheckPunish && !isCheckErrTable && !isCheckViolation" class="col-md-12">
          <img *ngIf="isDelete" src="assets/icons/icon-delete-notification.svg" alt="" style="margin-right: 0.5rem;">
          <img *ngIf="isWarning" src="../../../../assets/images/warning.png" alt="" style="margin-right: 0.5rem;">
          <img *ngIf="isErrors" src="../../../../assets/images/errorsThungRac.svg" alt="" style="margin-right: 0.5rem;">
          <img *ngIf="isSuccess" src="../../../../assets/images/successRing.svg" alt="" style="margin-right: 0.5rem;">
          <b class="fontTitle">{{title ? (title | translate) : ('BASE.NOTIFICATION' | translate)}}</b>
        </div>
        <div *ngIf="!isCheckPunish && !isCheckErrTable && !isCheckViolation" class="col-md-12">
          <p class="fixMess">{{messageNotification ? (messageNotification | translate) : ''}}</p>
        </div>

        <div *ngIf="username" class="col-md-12">
          <b class="fontTitle">{{username}}</b>
        </div>
        <div *ngIf="mail" class="col-md-12">
          <p class="fixMess">{{mail}}</p>
        </div>
        <div class="flex-container" *ngIf="uploadFile">
          <div class="icon"><i nz-icon nzType="icons:excel-icon" nzTheme="outline" aria-hidden="true"></i></div>
          <div class="file-name">
            <div>{{uploadFile?.name}}</div>
            <div>{{fileSize}} MB</div>
          </div>
        </div>
        <div *ngIf="isCheckPunish" class="col-md-12">
          <b class="fontTitle">Xoá hàng loạt nhóm lỗi</b>
        </div>
        <div *ngIf="isCheckErrTable" class="col-md-12">
          <b class="fontTitle">Xoá hàng loạt lỗi</b>
        </div>
        <div *ngIf="isCheckViolation" class="col-md-12">
          <b class="fontTitle">Xoá hàng loạt điểm trừ</b>
        </div>

        <div *ngIf="isCheckPunish" class="col-md-12 fixMess">
          <h6>Bạn có chắc chắn muốn xóa các nhóm lỗi:</h6>
          <ul>
            <li *ngFor="let name of selectedGroupName">{{name}}</li>
          </ul>
          <h6>không?</h6>
        </div>

        <div *ngIf="isCheckErrTable" class="col-md-12 fixMess">
          <h6>Bạn có chắc chắn muốn xóa các lỗi:</h6>
          <ul>
            <li *ngFor="let name of selectedGroupName">{{name.code}} - {{name.name}}</li>
          </ul>
          <h6>không?</h6>
        </div>

        <div *ngIf="isCheckViolation" class="col-md-12 fixMess">
          <h6>Bạn có chắc chắn muốn xóa các điểm trừ:</h6>
          <ul>
            <li *ngFor="let name of selectedGroupName">{{name.numberViolations}}</li>
          </ul>
          <h6>không?</h6>
        </div>

        <div *ngIf="isCheckFunctionMangement" class="list-menu-delete col-md-12">
          <span>Bạn đang thực hiện hành động:</span>
          <ul>
            <li *ngIf="checkedNodes?.ids?.length">
              <div>Xóa <strong>{{ checkedNodes?.ids?.length }}</strong> chức năng:</div>
              <ul>
                <ng-container *ngFor="let item of menus">
                  <li *ngIf="checkedNodes?.ids?.includes(item.id)">
                    {{ item.name ? (item.name | translate) : 'BASE.NOTIFICATION' | translate }}
                  </li>
                </ng-container>
              </ul>
            </li>
            <li *ngIf="checkedModules?.length">
              <div>Xóa <strong>{{ checkedModules?.length }}</strong> phân hệ:</div>
              <ul>
                <ng-container *ngFor="let item of checkedModules">
                  <li>
                    {{ item.title ? (item.title | translate) : 'BASE.NOTIFICATION' | translate }}
                  </li>
                </ng-container>
              </ul>
            </li>
          </ul>
          <p>Bạn có muốn thực hiện xóa không ?</p>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center btn-notify-group">
      <button *ngIf="isShowCancel" nz-button nzType="default" class="colorBtn" type="button"
        (click)="deleteCancel()">
        <div class="center">
          <!-- <i nz-icon nzType="close-circle" nzTheme="outline" aria-hidden="true"></i> -->
          <span class="px-2">{{labelCancel ? (labelCancel | translate) : 'Không'}}</span>
        </div>
      </button>

      <button nz-button nzType="primary" style="margin-left: 1rem;" class="colorBtnOkPopup" type="button" (click)="deleteOk()">
        <div class="center">
          <!-- <i nz-icon nzType="check-circle" nzTheme="outline" aria-hidden="true"></i> -->
          <span class="px-2">{{labelOk ? (labelOk | translate) : 'Đồng ý'}}</span>
        </div>
      </button>
    </div>
  </ng-container>
  <ng-template #closeIcon>
    <img src="/assets/icons/icon-close-popup.svg">
  </ng-template>

</nz-modal>